import {Component, Inject, inject, ChangeDetectionStrategy} from '@angular/core';
import {ModalRef} from "../../../shared-module/services/modal.service";
import {
  TelevisionDetailsDisplayComponent
} from "../../../shared-module/components/television-details-display/television-details-display.component";
import {ModalData} from "../../../shared-module/types/modal-data.type";
import {TelevisionProduct} from "../../../shared-module/model/product.model";

@Component({
    selector: 'app-television-details',
  imports: [
    TelevisionDetailsDisplayComponent,

  ],
    templateUrl: './television-details.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './television-details.component.scss'
})
export class TelevisionDetailsComponent {
  readonly modalRef: ModalRef<TelevisionDetailsComponent> = inject(ModalRef<TelevisionDetailsComponent>);

  // eslint-disable-next-line @angular-eslint/prefer-inject
  constructor(@Inject(ModalData) public television: TelevisionProduct) {}
}
